import React, { Component } from 'react';

import classes from './Article.module.scss';
import MediaQuery from 'react-responsive';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import $ from 'jquery';
import 'is-in-viewport';
import globalJSON from 'data/global.json';


import Hero from './Hero/Hero'
import HeroHead from './HeroHead/HeroHead'
import Intro from './Intro/Intro'
import Quote from './Quote/Quote'
import Summary from './Summary/Summary'
import ImageCard from './ImageCard/ImageCard'
import SimilarArticles from './SimilarArticles/SimilarArticles';
import GoldSocialIcon from './GoldSocialIcon/GoldSocialIcon';
import Author from './Author/Author';
import LongText from './LongText/LongText'
import Advert from 'components/App/Advert/Advert'
import { Helmet } from "react-helmet";
import { Online } from "react-detect-offline";
import IsNotDomestic from 'helpers/IsNotDomestic';
import MakeSticky from 'helpers/MakeSticky';
import Video from './Video/Video';


import { getFileName } from 'helpers/FileCaching';
const heroImages = require.context('images/components/Articles/Article/Hero', true, /.*\.(gif|png|jpe?g|svg)$/i);

class Article extends Component {

	constructor(props){
		super(props);
		
		//Display initial article and its content.

		this.pereviousScrollPercentage = 0;

		this.onScroll=this.onScroll.bind(this)
		window.addEventListener('scroll', this.onScroll)

	
		let progress25Tracked = false;
		let progress50Tracked = false;
		let progress75Tracked = false;
		let progress100Tracked = false;
	}

	

	onScroll(){

		var s = this.getCurrentPosition()

		this.heightOfArticle()

	}

	heightOfArticle(){
		
		var $articleElement = $('#articles_' + this.props.content.id);
		var articleHeight =$articleElement.outerHeight(true);
		var viewPort= window.innerHeight;
		var percentage = ((this.getCurrentPosition() + viewPort) - $articleElement.position().top)/articleHeight * 100;
		var minMaxPercentage = Math.min(100, Math.max(this.pereviousScrollPercentage, percentage));

		// to do tracking checks

		if(minMaxPercentage >= 25){
			if(!this.progress25Tracked) {
				window.gtag('event', "viewed articles_"+ this.props.content.title,{
				'event_category': globalJSON.tracking.ga_category,
	              	'event_label': "scroll 25% progress",
	              	'value':10
	          		});
					this.progress25Tracked = true;
				
			}
		}
		if(minMaxPercentage >= 50){
			if(!this.progress50Tracked) {
				window.gtag('event', "viewed articles_"+ this.props.content.title,{
				'event_category': globalJSON.tracking.ga_category,
	              	'event_label': "scroll 50% progress",
	              	'value':10
	          		});
					this.progress50Tracked = true;
				
			}

		}

		if(minMaxPercentage >= 75){
			if(!this.progress75Tracked) {
				window.gtag('event', "viewed articles_"+ this.props.content.title,{
				'event_category': globalJSON.tracking.ga_category,
	              	'event_label': "scroll 75% progress",
	              	'value':10
	          		});
					this.progress75Tracked = true;
				
			}
		 }
			if(minMaxPercentage >= 100){
				if(!this.progress100Tracked) {
					 window.gtag('event', "viewed articles_"+ this.props.content.title,{
					'event_category': globalJSON.tracking.ga_category,
	              	'event_label': "scroll 100% progress",
	              	'value':10
	          		});
						this.progress100Tracked = true;
					
				}
			}
			
			
		 	


		this.pereviousScrollPercentage= minMaxPercentage;


	
	}
	
	getMetaImage = (localImageFilePath) => {

		let socialImageStr = String(getFileName(heroImages, this.props.content.social['twitter-image']))
		let base64Check = socialImageStr.match(/data:image/gi) !== null

		if(base64Check){
			return socialImageStr
		}else{
			return globalJSON.live_url+localImageFilePath
		}

	}

	getCurrentPosition = () => {
		return Math.abs(( window.scrollY || document.body.scrollTop || document.documentElement.scrollTop));
	}
	
	componentWillUnmount(){

		window.removeEventListener("scroll", this.onScroll);
	}

    render(){
		
        return (

            <div className={classes.article} id={`articles_${this.props.content.id}`} ref={`articles_${this.props.id}`}>
			
				<Helmet
					title={this.props.content.title}
					meta={
						[
							{
								name: "fb:app_id",
								content: globalJSON.social.fb_app_id
							},
							{
								name: "keywords",
								content: ""
							},
							{
								name: "description",
								content: this.props.content.description
							},
							{
								property: "og:url",
								content: globalJSON.live_url+process.env.PUBLIC_URL+'/'+this.props.content.url
							},
							{
								property: "og:type",
								content: "article"
							},
							{
								property: "og:title",
								content: this.props.content.title
							},
							{
								property: "og:description",
								content: this.props.content.description
							},
							{
								property: "og:image",
								content: this.getMetaImage(getFileName(heroImages, this.props.content.hero.image.desktop))
							},
							{
								property: "twitter:card",
								content: "summary_large_image"
							},
							{
								property: "twitter:site",
								content: "@BBC_Future"
							},								
							{
								property: "twitter:title",
								content: this.props.content.title
							},
							{
								property: "twitter:description",
								content: this.props.content.description
							},
							{
								property: "twitter:image",
								content: this.getMetaImage(getFileName(heroImages, this.props.content.social['twitter-image']))
							}
						]
					}
				/>
				<section className={classes.article__header}>
					
					<HeroHead></HeroHead>

					<Hero windowSize={this.props.windowSize} socialContent={this.props.content.social} url={this.props.content.url} content={this.props.content.hero} />

					<MediaQuery minWidth={classes.screenLg}>
						<SimilarArticles content={this.props.content.similarArticles}  />
					</MediaQuery>

				</section> 

				<section className={classes.article__content}>
					
					<div className={classes['article__contentLeft']}>

						<MediaQuery minWidth={classes.screenXl}>
							<Author content={this.props.content.authorID} />
							<IsNotDomestic>
								<Online>	
									<MakeSticky>
										<div className={`MPU`} id={`articles_mpu_${this.props.content.id}`} ref={`articles_mpu_${this.props.id}`}>
											<MediaQuery minWidth={classes.screenLg}>
												<DFPSlotsProvider targetingArguments={{ column: globalJSON.advertising.column }} dfpNetworkId={`${globalJSON.advertising.networkID}`} adUnit={`${globalJSON.advertising.adUnit}`}>
													<div className={`MPU__Wrapper`}>
														<div className={`MPU__mpu`}>
															<p className={`ads_title MPU__Title`}>advertisement</p>
															<div className={`MPU__Ads`}>
																<AdSlot sizes={[ [300, 250] ]} />
															</div>
														</div>
													</div>
												</DFPSlotsProvider>
											</MediaQuery>
										</div>
									</MakeSticky>
								</Online>
							</IsNotDomestic>
						</MediaQuery>

					</div>

					<div className={classes['article__content-sections']}>

						{
							this.props.content.sections.map((item, index) => {

								let compnent;
				
								switch(item.componentName) {
									
									case 'Intro':
				
										compnent = <Intro content={item} />
										break;
				
									case 'Summary':
				
										compnent =  <Summary authorID={this.props.content.authorID} summaryIndex={index} content={item} />
										break;
				
									case 'Quote':

										compnent =  <Quote windowSize={this.props.windowSize} socialContent={this.props.content.social} url={this.props.content.url} content={item} />
										break;
				
									case 'ImageCard':
				
										compnent =  <ImageCard windowSize={this.props.windowSize} content={item} />
										break;
				
									case 'LongText':
				
										compnent =  <LongText content={item} />
										break;

									case 'Video':
										compnent =  <Video content={item['video']} windowSize={this.props.windowSize}  />
										break;
				
									}
				
								let markup =
				
									<div key={index} className={classes['article__content-section']}>
										{compnent}
									</div>
				
								return markup;
				
							})
						}

						<div>

						<div className={` ${classes['article__content-sections-socialContainer']}`}>
							<div className={`divider`}></div>
								{/* <GoldSocialIcon content={this.props.content} /> */}
								<GoldSocialIcon content={this.props.content.social} url={`${globalJSON.live_url}${process.env.PUBLIC_URL}/${this.props.content.url}`} />
								
						</div>
						
							<MediaQuery maxWidth={classes.screenMaxLg}>
								<SimilarArticles content={this.props.content.similarArticles}  />
							</MediaQuery>

						</div>
				
					</div>

				</section>
				<Advert/>				
            </div>
		);


		
    }
}

export default Article;